import blogImage from "../../../assets/blog.jpg";
import HomeHeaderService from "../../../services/HomeHeaderService";
import "./style.css";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const Projects = () => {
	const [data, setData] = useState([]);
	const [informations, setInformations] = useState({
		projects: "",
		employees: "",
		countries: "",
		continents: "",
	});
	const { t } = useTranslation();

	useEffect(() => {
		new HomeHeaderService().getList("homeProject").then((res) => {
			if (res.status === 200) {
				let response = res?.data?.data;
				setInformations({
					projects: response?.projects,
					employees: response?.employees,
					countries: response?.countries,
					continents: response?.continents,
				});
				setData(response?.home_project_images?.map((img) => img?.url));
			}
		});
	}, []);

	return (
		<div className="our-projects" id="projects" data-aos="zoom-in">
			<div className="images">
				<div className="container">
					<p className="title">{t("Our Projects")}</p>
					<div className="images-data">
						{data?.map((image, index) => {
							return <img key={index} src={image} alt="project" />;
						})}
					</div>
					<div className="images-mob">
						<Swiper
							slidesPerView={2}
							spaceBetween={24}
							pagination={{
								clickable: true,
							}}
							navigation
							scrollbar={{ draggable: true }}
							modules={[Navigation]}
							className="mySwiper">
							{data?.map((image, index) => {
								return (
									<SwiperSlide className="text-center" key={index}>
										<img key={index} src={image} alt="project" />
									</SwiperSlide>
								);
							})}
						</Swiper>
					</div>
				</div>
			</div>
			<div className="informations">
				<div className="container">
					<div className="row">
						<div className="col-md-3 col-6">
							<span>{informations?.projects}</span>
							<p>{t("Projects")}</p>
						</div>
						<div className="col-md-3 col-6">
							<span>{informations?.employees}</span>
							<p>{t("Employees")}</p>
						</div>
						<div className="col-md-3 col-6">
							<span>{informations?.countries}</span>
							<p>{t("Countries")}</p>
						</div>
						<div className="col-md-3 col-6">
							<span>{informations?.continents}</span>
							<p>{t("Continents")}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default Projects;
